<body data-cy="form-builder-body">

<div class="top-header" data-cy="form-builder-header">

  <div class="top-header-item" style="width: 400px" data-cy="form-builder-form-container">
    <dx-text-box
      placeholder="Select a Form"
      [buttons]="formOpenButtons"
      [(ngModel)]="selectedForm.DFormName"
      label="Form"
      labelMode="floating"
      data-cy="form-builder-form-input"
    ></dx-text-box>
  </div>
  <div class="top-header-item" style="width: 80px" data-cy="form-builder-version-container">
    <dx-text-box
      [(ngModel)]="selectedVersion.Version"
      label="Version"
      labelMode="floating"
      data-cy="form-builder-version-input"
    >
    </dx-text-box>
  </div>
  <div class="top-header-item" data-cy="form-builder-category-container">
  <dx-select-box
    [items]="formCategories_enumValidValueItem"
    valueExpr="ValidValueItemId"
    displayExpr="ItemDisplayValue"
    [(value)]="selectedForm.enumFormCategoryID"
    label="Form Category"
    labelMode="floating"
    data-cy="form-builder-category-select"
  >
  </dx-select-box>
  </div>
  <div class="top-header-item" data-cy="form-builder-datasource-container">
    <dx-select-box
      [items]="formDatSource_enumValidValueItem"
      valueExpr="ValidValueItemId"
      displayExpr="ItemDisplayValue"
      [(value)]="selectedForm.enumFormDataSourceID"
      label="Form DataSource"
      labelMode="floating"
      data-cy="form-builder-datasource-select"
    >
    </dx-select-box>
  </div>
  <div class="top-header-item" style="width: 250px" data-cy="form-builder-custom-container">
    <dx-select-box
      [items]="enumCustomForm_enumValidValueItem"
      valueExpr="ValidValueItemId"
      displayExpr="ItemDisplayValue"
      [(value)]="selectedForm.enumCustomFormID"
      label="Custom Form"
      labelMode="floating"
      data-cy="form-builder-custom-select"
    >
    </dx-select-box>
  </div>
  <div data-cy="form-builder-buttons-container">
    <dx-button
       text="Save"
       data-cy="form-builder-save-button">
    </dx-button>
    <dx-button
      text="View"
      data-cy="form-builder-view-button">
    </dx-button>
  </div>

</div>

</body>
